import { gql } from "@apollo/client";

export const GET_CUSTOMER_FEEDBACK_REPORT = gql`
  query GetCustomerFeedbackReport($filter: CustomerFeedbackFilter) {
    getCustomerFeedbackReport(filter: $filter) {
      status
      message
      data {
        summary {
          totalReviews
          reviewedCompleted
          completedOrders
          legacyCount
          lowReviews
          avgServiceRating
          serviceRated
          avgProductRating
          productRated
          serviceCounts
          productCounts
          flaggedCount
          flaggedToCall
          openIssues
          commentCount
          publicCount
        }
        employees {
          employeeId
          employeeName
          reviews
          reviewedCompleted
          completedOrders
          avgServiceRating
          fairServiceScore
          serviceRated
          avgProductRating
          productRated
          serviceCounts
          lowCount
          flaggedCount
          commentCount
          lastReviewedOn
          prevAvgServiceRating
          prevServiceRated
          topComplaints {
            option
            count
          }
        }
        previous {
          startDate
          endDate
          totalReviews
          avgServiceRating
          avgProductRating
          lowReviews
        }
        recovery {
          flagged
          called
          calledRebooked
          calledUntimed
          notCalled
          notCalledRebooked
          others
          othersRebooked
          timedCalls
          medianHoursToCall
        }
        trendBucket
        reasons {
          question
          targetType
          option
          count
          avgRating
        }
        trend {
          date
          reviews
          avgServiceRating
        }
      }
    }
  }
`;

export const GET_CUSTOMER_FEEDBACK_REVIEWS = gql`
  query GetCustomerFeedbackReviews($filter: CustomerFeedbackFilter, $limit: Int, $offset: Int) {
    getCustomerFeedbackReviews(filter: $filter, limit: $limit, offset: $offset) {
      status
      message
      data {
        total
        reviews {
          feedbackId
          orderId
          bookingId
          bookingDate
          submittedAt
          employeeId
          employeeName
          customerName
          customerPhone
          services
          serviceRating
          serviceComment
          productRating
          productComment
          isFlagged
          reviewPublic
          isLegacy
          nextBookingDate
          feedbackCallStatus
          feedbackCallComment
          feedbackIssueStatus
          feedbackIssueDetails
          feedbackResolutionDetails
          feedbackResolvedAt
          feedbackCallAt
          feedbackCallBy
          feedbackCallAttempts
          answers {
            question
            targetType
            options
            text
          }
        }
      }
    }
  }
`;
